import type { Directive, DirectiveBinding } from 'vue'
import { usePermission } from '@/composables/usePermission'

export const permissionDirective: Directive<HTMLElement, string> = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const { hasPermission } = usePermission()
    if (!hasPermission(binding.value)) {
      el.parentNode?.removeChild(el)
    }
  },
}
